import React, { useState } from 'react';
import { auth } from '../firebase';
import { sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

const ResetPassword = () => {
    const [email, setEmail] = useState('');
    const navigate = useNavigate();

    const handleResetPassword = async (e) => {
        e.preventDefault();
        try {
            await sendPasswordResetEmail(auth, email);
            alert('Password reset email sent');
            navigate('/login');
        } catch (error) {
            console.error('Error resetting password:', error);
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen">
            <form onSubmit={handleResetPassword} className="bg-gradient-to-r from-green-400 to-teal-400 p-6 rounded shadow-md w-full max-w-sm">
                <h2 className="text-white font-bold text-2xl mb-4">Reset Password</h2>
                <div className="mb-4">
                    <label className="block text-white font-light">Email</label>
                    <input 
                        type="email" 
                        value={email} 
                        onChange={(e) => setEmail(e.target.value)} 
                        className="text-black w-full p-2 border border-gray-300 rounded mt-1"
                        required 
                    />
                </div>
                <button type="submit" className="w-full bg-teal-500 text-white p-2 rounded mb-4">Reset Password</button>
            </form>
        </div>
    );
};

export default ResetPassword;